// src/utils/firebase/eventLogger.js
//
// Frontend event logger — dual-write companion to statusLogger.js.
// Sends structured events to the unified eventLog collection via
// the logFrontendEvent callable cloud function.
//
// Usage:
//   import { logEvent } from '@/utils/firebase/eventLogger';
//   await logEvent({
//     eventType: 'CUSTOMER_UPDATED',
//     action: 'update',
//     resource: { type: 'customer', id: customerId },
//     changes: { fields: ['contact.email'], before: { ... }, after: { ... } },
//     context: { metadata: { source: 'CustomerDetail' } },
//   });

import { getFunctions, httpsCallable } from 'firebase/functions'

const functions = getFunctions()
const logEventFn = httpsCallable(functions, 'logFrontendEvent')

export async function logEvent({
  eventType,
  action,
  resource,
  changes,
  context,
  throwOnError = false,
}) {
  try {
    await logEventFn({ eventType, action, resource, changes, context })
  } catch (err) {
    console.warn('[eventLogger] Failed to log event:', err.message)
    if (throwOnError) throw err
  }
}
